export default "__VITE_ASSET__$fg69_uj__"